/***************************************************************************
 * FILTER LIST ACCORDION
 * This script will handle the accordion functionality in the filter list
 * view. It will open & close the accordions on click on a occurrence row.
 **************************************************************************/

/**
 * GET FILTER LIST ROWS
 *
 * This function will get the
 * DOM of the filter list rows.
 *
 * @requires string
 *
 * @return HTMLCollection
 */
function getFilterListRows() {
    return document.getElementsByClassName('occurrenceRow');
}


/**
 * SET ACCORDION
 *
 * This function will create
 * an accordion with the
 * transmitted array.
 *
 * @requires array
 *
 * @return DOM
 */
function setAccordion(accordionArray) {
    if (accordionArray) {
        for (var i = 0; i < accordionArray.length; i++) {
            var accordionUlElement = accordionArray[i].getElementsByTagName('UL')[0];
            accordionUlElement.addEventListener('click', function() {
                // remove active state when already active
                if (this.classList.contains('active')) {
                    this.classList.remove('active');
                    this.nextElementSibling.style.maxHeight = null;
                    return;
                }

                // remove all active states
                for (var x = 0; x < accordionArray.length; x++) {
                    var currentAccordionElement = accordionArray[x].getElementsByTagName('UL')[0];
                    if (currentAccordionElement.classList.contains('active') && this !== currentAccordionElement) {
                        currentAccordionElement.classList.remove('active');
                    }
                    currentAccordionElement.nextElementSibling.style.maxHeight = null;
                }

                // add active state
                this.classList.add('active');
                this.nextElementSibling.style.maxHeight = this.nextElementSibling.scrollHeight + 'px';
            });
        }
        return;
    }
    return false;
}


// Execute functions
document.addEventListener('DOMContentLoaded', function() {
    setAccordion(getFilterListRows());
});